import React, { useEffect } from "react";
import "../services/socialLogins/google.init";
import "../i18n/i18n";
import { ThemeProvider } from "../config";
import { Provider, useDispatch } from "react-redux";
import { store } from "../store";
import LS from "../utils/localStorageUtils";
import { checkAuthRequest, rehydrateAuth } from "../store/auth/authActions";
import Toast from "react-native-toast-message";
import { StyleSheet, View } from "react-native";
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n/i18n";
import { i18nLoadRequest } from "../store/i18n/i18nActions";
import { useLanguageInit } from "../utils/helpers/languages";
import { Platform } from "react-native";

import { firebaseAnalytics } from "../services/firebase/firebase.service";
import { analyticsEvents } from "../services/firebase/analytics-events.service";
import { cleverTapService } from "../services/clevertap/clevertap.service";
import { SafeAreaProvider } from "react-native-safe-area-context";
import AuthGate from "./Components/AuthGate";
import { configureGoogle } from "../services/socialLogins/google.config";

const Bootstrap = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (Platform.OS !== "web") {
      console.log("[GoogleSignIn] configuring Google Sign-In (native)");
      configureGoogle();
    }
  }, []);
  useEffect(() => {
    console.log("[BOOTSTRAP] Mounted on platform:", Platform.OS);
  }, []);

  useEffect(() => {
    // Initialize Firebase Analytics (with error handling)
    if (
      firebaseAnalytics &&
      typeof firebaseAnalytics.initialize === "function"
    ) {
      firebaseAnalytics
        .initialize()
        .then(() => {
          console.log("[App] Firebase initialized");
          analyticsEvents.trackPageView();
        })
        .catch((error: any) => {
          console.warn("[App] Firebase initialization failed:", error);
        });
    } else {
      console.warn(
        "[App] firebaseAnalytics is not available or not properly initialized",
      );
    }

    // Initialize CleverTap
    cleverTapService
      .initialize()
      .then(() => {
        console.log("[App] CleverTap initialized");
      })
      .catch((error: any) => {
        console.warn("[App] CleverTap initialization failed:", error);
      });
  }, []);

  useEffect(() => {
    dispatch(checkAuthRequest());
  }, [dispatch]);

  useLanguageInit();

  return <AuthGate />;
};

const App = () => (
  <>
    <Provider store={store}>
      <SafeAreaProvider>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider>
            <Bootstrap />
          </ThemeProvider>
        </I18nextProvider>
      </SafeAreaProvider>
    </Provider>
    <View pointerEvents="box-none" style={styles.toastHost}>
      <Toast />
    </View>
  </>
);

const styles = StyleSheet.create({
  toastHost: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: "flex-end",
    alignItems: "center",
    paddingBottom: 20,
    zIndex: 999999,
    elevation: 999999,
    pointerEvents: "box-none",
  },
});

export default App;
